import API from '../api'
import getUrl from './paths'

const getJourneyBySourceId = (journeySourceId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getJourneyBySourceId, { journeySourceId, removeDefault: true })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

// entityType: 'Order' | 'Enquiry', referenceId: order id / enquiry id
const getEntityHistoryVersions = (entityType, referenceId) =>
	new Promise((resolve, reject) => {
		API.get(`${getUrl.getEntityHistoryVersions}${entityType}/${referenceId}/versions`, { removeDefault: true })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

// entityType: 'Order' | 'Enquiry' | 'Organisation', referenceId: order id / enquiry id / organisation id
const getEntityHistoryVersion = (entityType, referenceId, version) =>
	new Promise((resolve, reject) => {
		API.get(`${getUrl.getEntityHistoryVersions}${entityType}/${referenceId}/version/${version}`, { removeDefault: true })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export { getJourneyBySourceId, getEntityHistoryVersions, getEntityHistoryVersion }
